import { Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SideSocialLinks from './components/SideSocialLinks';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailsPage from './pages/ProductDetailsPage';
import ServicePage from './pages/ServicePage';
import HelmetsPage from './pages/HelmetsPage';
import DiyPage from './pages/DiyPage';
import SafetyPage from './pages/SafetyPage';
import ProtectiveEquipmentPage from './pages/ProtectiveEquipmentPage';
import ElectricSkateboardsPage from './pages/ElectricSkateboardsPage';
import BlogPage from './pages/BlogPage';
import FreebordPage from './pages/FreebordPage';
import PopupForm from './components/PopupForm';
import { CartProvider } from './context/CartContext';
import CartSidebar from './components/CartSidebar';
import NoOnlinePurchaseModal from './components/NoOnlinePurchaseModal';
import FloatingCartButton from './components/FloatingCartButton';
import { PopupFormProvider } from './components/PopupForm';
import { useEffect } from 'react';
import ProfilePage from './pages/ProfilePage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <PopupFormProvider>
          <div className="flex flex-col min-h-screen">
            <Navbar />
            <SideSocialLinks />
            <ScrollToTop />
            <main className="flex-grow pt-16">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/products/:id" element={<ProductDetailsPage />} />
                <Route path="/service" element={<ServicePage />} />
                <Route path="/helmets" element={<HelmetsPage />} />
                <Route path="/diy" element={<DiyPage />} />
                <Route path="/safety" element={<SafetyPage />} />
                <Route path="/protective-equipment" element={<ProtectiveEquipmentPage />} />
                <Route path="/electric-skateboards" element={<ElectricSkateboardsPage />} />
                <Route path="/freebord" element={<FreebordPage />} />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/profile" element={<ProfilePage />} />
              </Routes>
            </main>
            <Footer />
            <PopupForm />
            <CartSidebar />
            <NoOnlinePurchaseModal />
          </div>
          <FloatingCartButton />
        </PopupFormProvider>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
